import { useState, useEffect } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function Settings() {
  const [form, setForm] = useState({ company_name: "US Operations" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/settings");
      setForm({ company_name: data.company_name || "US Operations" });
      setLoading(false);
    })();
  }, []);

  const save = async (e) => {
    e.preventDefault();
    try {
      await api.put("/settings", { company_name: form.company_name });
      toast.success("Settings saved");
    } catch (err) { toast.error(formatApiError(err)); }
  };

  if (loading) return <div className="font-display uppercase">Loading...</div>;

  return (
    <div className="space-y-6 max-w-2xl" data-testid="settings-page">
      <div>
        <h1 className="font-display text-4xl uppercase tracking-tighter">Settings</h1>
        <p className="text-xs text-slate-600 mt-1">Admin only · global configuration</p>
      </div>

      <form onSubmit={save} className="brut-card p-6 space-y-4" data-testid="settings-form">
        <div>
          <label className="brut-label">Company / Brand Name</label>
          <input
            value={form.company_name}
            onChange={(e) => setForm({ ...form, company_name: e.target.value })}
            className="brut-input mt-1"
            data-testid="settings-company"
          />
          <p className="text-xs text-slate-500 mt-1">Appears on printed GRNs, run slips, box slips, packing lists and 4×6 labels.</p>
        </div>
        <p className="text-xs text-slate-500">
          Box size is now configured per-part via "Assemblies per Box" on shippable parts.
          Packing Lists may contain any combination of boxes — no global multiple restriction.
        </p>
        <button type="submit" className="brut-btn brut-btn-primary px-4 py-2" data-testid="save-settings-btn">Save Settings</button>
      </form>
    </div>
  );
}
